import ZenDesk from "./containers/ZenDeskContainer";
export * from "./components/ZenDeskWidget";

export { ZenDesk };
